module.exports = __webpack_public_path__ + "img/40.2215595f.jpg";